import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import StorefrontLayout from '../components/layout/StorefrontLayout';

export default function NotFoundPage() {
  const { t } = useTranslation();
  const location = useLocation();
  const path = `${location.pathname}${location.search}${location.hash}`;

  return (
    <StorefrontLayout mainClassName="bg-slate-50" contentContained>
      <div className="mx-auto w-full max-w-3xl py-12">
        <div className="rounded-2xl border border-slate-200 bg-white p-8 shadow-sm">
          <p className="text-xs font-semibold uppercase tracking-wide text-slate-500">{t('public.notfound_code')}</p>
          <h1 className="mt-2 workspace-page-title">
            {t('public.notfound_title')}
          </h1>
          <p className="mt-3 text-sm leading-relaxed text-slate-600">
            {t('public.notfound_body', { path })}
          </p>

          <div className="mt-6 flex flex-col gap-3 sm:flex-row">
            <Link
              to="/"
              className="inline-flex items-center justify-center rounded-full bg-[#00b853] px-6 py-3 text-sm font-semibold text-white hover:bg-[#009946]"
            >
              {t('public.notfound_home')}
            </Link>
            <Link
              to="/products"
              className="inline-flex items-center justify-center rounded-full border border-slate-200 bg-white px-6 py-3 text-sm font-semibold text-slate-700 hover:bg-slate-50"
            >
              {t('public.notfound_products')}
            </Link>
          </div>
        </div>
      </div>
    </StorefrontLayout>
  );
}
